<ng-container *ngIf="initialized && dto">

    @if (viewType == CmContractInlineObjectViewTypeUiEnum.standard) {
        <cm-contract-inline-component [objectIdentifier]="objectIdentifier" [dto]="dto"></cm-contract-inline-component>
    }

    @if (viewType == CmContractInlineObjectViewTypeUiEnum.object) {

        <cm-contract-inline-component [objectIdentifier]="objectIdentifier" [dto]="dto"></cm-contract-inline-component>

        @if (contractInsurableObjects?.length) {
            <div class="flex flex-wrap gap-2">
                @for (object of contractInsurableObjects; track object.id) {
                    <div class="p-2 bg-gray-50">
                        <div class="flex align-items-center gap-2">
                            @if (object?.insurableObjectDto?.typeDto?.euImage) {
                                <img [src]="object?.insurableObjectDto?.typeDto?.euImage" alt="Insurable object"
                                     class="w-2rem"/>
                            }
                            <span>{{ object?.insurableObjectDto?.formatName }}</span>
                        </div>

                    </div>
                }
            </div>
        }
    }
</ng-container>
